var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlocksPreferences = function SvgBlocksPreferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 269,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M55.73 133.31h-9.685v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.16c-1.06 0-1.92.877-1.92 1.955v9.355h-9.686c-1.256 0-2.27 1.032-2.27 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.731 133.31h-9.686v-9.355c0-1.078-.86-1.955-1.919-1.955H29.965c-1.059 0-1.92.877-1.92 1.955v9.355H18.36c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.256 0 2.27-1.032 2.27-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M24.341 122.009h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M24.296 122h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M49.094 133.31H12.816c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.26 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.26-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.955 154.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.717 145.67c-4.125.832-7.237 4.541-7.237 8.99s3.112 8.158 7.237 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M55.73 178.31h-9.685v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.16c-1.06 0-1.92.877-1.92 1.955v9.355h-9.686c-1.256 0-2.27 1.032-2.27 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.731 178.31h-9.686v-9.355c0-1.078-.86-1.955-1.919-1.955H29.965c-1.059 0-1.92.877-1.92 1.955v9.355H18.36c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.256 0 2.27-1.032 2.27-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M24.341 167.009h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M24.296 167h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M49.094 178.31H12.816c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.26 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.26-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.955 199.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.717 190.67c-4.125.832-7.237 4.541-7.237 8.99s3.112 8.158 7.237 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M55.73 223.31h-9.685v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.16c-1.06 0-1.92.877-1.92 1.955v9.355h-9.686c-1.256 0-2.27 1.032-2.27 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.731 223.31h-9.686v-9.355c0-1.078-.86-1.955-1.919-1.955H29.965c-1.059 0-1.92.877-1.92 1.955v9.355H18.36c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.256 0 2.27-1.032 2.27-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M24.341 212.009h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M24.296 212h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M49.094 223.31H12.816c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.26 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.26-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.955 244.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.717 235.67c-4.125.832-7.237 4.541-7.237 8.99s3.112 8.158 7.237 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M55.73 268.31h-9.685v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.16c-1.06 0-1.92.877-1.92 1.955v9.355h-9.686c-1.256 0-2.27 1.032-2.27 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M55.731 268.31h-9.686v-9.355c0-1.078-.86-1.955-1.919-1.955H29.965c-1.059 0-1.92.877-1.92 1.955v9.355H18.36c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.27 2.311H55.73c1.256 0 2.27-1.032 2.27-2.311v-38.068c0-1.279-1.014-2.311-2.27-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M24.341 257.009h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M24.296 257h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M49.094 268.31H12.816c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.26 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.26-2.868-2.816-2.868M163.731 21.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311V61.69c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311V23.62c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M163.731 21.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311V61.69c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311V23.62c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M132.341 10.01h13.229c1.318 0 2.385 1.086 2.385 2.43v8.879h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M132.296 10h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M157.094 21.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.954c0 1.584 1.261 2.868 2.816 2.868h36.278c1.555 0 2.816-1.284 2.816-2.868V24.178c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.955 42.66c0-5.061-4.028-9.164-8.996-9.164s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.717 33.67c-4.125.832-7.238 4.54-7.238 8.99 0 4.449 3.113 8.158 7.238 8.989 4.126-.831 7.238-4.54 7.238-8.99 0-4.448-3.112-8.157-7.238-8.989",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M163.731 66.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311V68.621c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M163.731 66.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311V68.621c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M132.341 55.01h13.229c1.318 0 2.385 1.086 2.385 2.43v8.879h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M132.296 55h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M157.094 66.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869V69.178c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.955 87.66c0-5.061-4.028-9.164-8.996-9.164s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.717 78.67c-4.125.832-7.238 4.54-7.238 8.99 0 4.449 3.113 8.158 7.238 8.989 4.126-.831 7.238-4.54 7.238-8.99 0-4.448-3.112-8.157-7.238-8.989",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M163.731 111.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M163.731 111.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M132.341 100.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M132.296 100h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M157.094 111.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.955 132.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.717 123.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M163.731 156.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M163.731 156.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M132.341 145.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M132.296 145h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M157.094 156.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.955 177.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.717 168.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M163.731 201.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M163.731 201.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M132.341 190.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M132.296 190h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M157.094 201.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.955 222.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.717 213.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M163.731 246.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M163.731 246.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M132.341 235.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M132.296 235h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M157.094 246.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M147.955 267.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M140.717 258.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M271.731 94.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311V96.621c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M271.731 94.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311V96.621c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M240.341 83.01h13.229c1.318 0 2.385 1.086 2.385 2.43v8.879h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M240.296 83h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M265.094 94.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869V97.178c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M255.955 115.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M248.717 106.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M271.731 139.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M271.731 139.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M240.341 128.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M240.296 128h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M265.094 139.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M255.955 160.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M248.717 151.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M271.731 184.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M271.731 184.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M240.341 173.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M240.296 173h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M265.094 184.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M255.955 205.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M248.717 196.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M271.731 229.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M271.731 229.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M240.341 218.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M240.296 218h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M265.094 229.31h-36.278c-1.555 0-2.816 1.284-2.816 2.868v36.953c0 1.585 1.261 2.869 2.816 2.869h36.278c1.555 0 2.816-1.284 2.816-2.869v-36.953c0-1.584-1.261-2.868-2.816-2.868"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M255.955 250.659c0-5.06-4.028-9.163-8.996-9.163s-8.995 4.103-8.995 9.163 4.027 9.163 8.995 9.163 8.996-4.102 8.996-9.163",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M248.717 241.67c-4.125.832-7.238 4.541-7.238 8.99s3.113 8.158 7.238 8.989c4.126-.831 7.238-4.54 7.238-8.989s-3.112-8.158-7.238-8.99",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M271.731 274.31h-9.686v-9.355c0-1.078-.861-1.955-1.92-1.955h-14.161c-1.058 0-1.919.877-1.919 1.955v9.355h-9.686c-1.256 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.013 2.311 2.269 2.311h37.372c1.255 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.014-2.311-2.269-2.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M271.731 274.31h-9.686v-9.355c0-1.078-.861-1.955-1.919-1.955h-14.161c-1.059 0-1.92.877-1.92 1.955v9.355h-9.686c-1.255 0-2.269 1.032-2.269 2.311v38.068c0 1.279 1.014 2.311 2.269 2.311h37.372c1.256 0 2.269-1.032 2.269-2.311v-38.068c0-1.279-1.013-2.311-2.269-2.311",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#86BD3D",
    d: "M240.341 263.009h13.229c1.318 0 2.385 1.087 2.385 2.43v8.88h-18v-8.88c0-1.343 1.068-2.43 2.386-2.43"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C6C6",
    d: "M240.296 263h13.228c1.319 0 2.386 1.087 2.386 2.43v8.88h-18v-8.88c0-1.343 1.067-2.43 2.386-2.43",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }));
};
export { SvgBlocksPreferences as ReactComponent };